export class HololinkError extends Error {
    constructor(...args) {
        super(...args);
        const userMessage = args.find(a => a.userMessage);
        if (userMessage)
            this.userMessage = userMessage.userMessage;
    }
}
